import { render, staticRenderFns } from "./listado-mails.vue?vue&type=template&id=5cd1c51e&scoped=true"
import script from "./listado-mails.vue?vue&type=script&lang=js"
export * from "./listado-mails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1c51e",
  null
  
)

export default component.exports